
import { AppealData, ShortAppealData } from './AppealReferanceModels';
import { AlarmEnum } from './GenericModels'
import { ClientProcessingService, MobileService } from './ServiceModels';

export interface AttachPersonalAccountCommand {
    personalAccount: number;
    serviceObjectId: number;

}


export interface AccountShortInformation {
    personalAccountId: string;
    personalAccount: string;
    balanceCurrent: number;

    serviceObjectId: number;
    address: string;

    dateAttach: Date | null;

    services: AccountService[];

    debitCategoryAlarm: AlarmEnum;
    debitCategory: string;
    availableServices: MobileService[]
}



export interface PersonalAccountInformation {
    balance: PersonalAccountBalance;
    services: PersonalAccountService[];
    //accessMobileAppDomRu: AccessMobileAppDomRu|null;
    serviceObjectId: number;
    availableServices: MobileService[]
    processingServices: ClientProcessingService[];
    appeals: ShortAppealData[];
    dateLoad: Date;
}

export interface AccountService {
    serviceId: string;
    serviceName: string;
    status: string;
    price: number | null;
    volume: number | null;
    discount: number | null;
    amount: number | null;
    isActive: boolean;
    serviceStatusAlarm: AlarmEnum;

    serviceFullName: string | null;
}

export interface PersonalAccountMovements {

    kind: string;
    year: number;
    january: number;
    february: number;
    march: number;
    april: number;
    may: number;
    june: number;
    jule: number;
    august: number;
    september: number;
    october: number;
    november: number;
    december: number;
    allYear: number;

}

export interface PersonalAccountBalance {
    personalAccountId: string;
    personalAccount: string;
    balanceCurrent: number;
    balanceKvartal: number;
    balanceYear: number;
    address: string;
    dateAttach: Date | null;
    movements: PersonalAccountMovements[];
}

/*
        {
            balance: {
                personalAccountId: "",
                personalAccount: "",
                balanceCurrent: 0,
                balanceKvartal: 0,
                balanceYear: 0,
                address: "",
                dateAttach: new Date(),
                movements: []

            },
            services: [],
            serviceObjectId: 0,
            availableServices: [],
            appeals: [],
            dateLoad: new Date()
        }
 */

export interface PersonalAccountService {
    serviceId: string;
    serviceName: string;
    serviceFullName: string | null;
    status: string;
    price: number | null;
    volume: number | null;
    discount: number | null;
    amount: number | null;
    isActive: boolean;
    serviceStatusAlarm: AlarmEnum;
    debitorCategoryAlarm: AlarmEnum;
    debitorCategory: string;

    //Подписки
    isRenewal: boolean,
    dateStart: Date | null,
    dateEnd: Date | null,
    dateRenewal: Date | null,
    cardFirst4: string | null,
    cardLast4: string | null,


}

export enum MovementType {
    None = 0,
    Arrival = 1,
    Spending = 2,
}


export interface MovementViewModel {
    year: number;
    accruals: AccrualViewModel[];

}

export interface AccrualViewModel {
    type: MovementType;
    kind: string;
    year: number;
    values: number[];
}


export interface PersonalAccountAvailableEquipment {
    personalAccountId: string;
    availableEquipment: AvailableEquipment[];
}


export interface AvailableEquipment {

    equipmentId: string,
    equipmentName: string,
    equipmentFullName: string,
    equipmentDescription: string,
    typeName: string,
    type: number,
    specifications: AvailableEquipmentSpecification[]
    images: AvailableEquipmentImage[]
}



export interface AvailableEquipmentSpecification {
    specificationId: string,
    nameSpecification: string,
    valueSpecification: string,
    orderNumber: number
}

export interface AvailableEquipmentImage {
    imageId: string,
    type: number,
    name: string,
    extension: string,
    orderNumber: number
}


export interface AccessMobileAppDomRu {
    login: string| null;
    password: string| null;

}